/**
 * GraphQL queries and hooks — technologyProductFamily pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { TechnologyProductFamily } from '../types/technologyProductFamily';

const LIST_TECHNOLOGY_PRODUCT_FAMILIES = gql`
  query ListTechnologyProductFamilies {
    technologyProductFamilies {
      entityId
      entityType
      name
      description
      tags
      technologyProductCount
      _schemaVersion
      _createdAt
      _createdBy
      _updatedAt
      _updatedBy
    }
  }
`;

export function useTechnologyProductFamilies(): QueryResult<{
  technologyProductFamilies: TechnologyProductFamily[];
}> {
  return useQuery(LIST_TECHNOLOGY_PRODUCT_FAMILIES, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
}

// ─── Project Tracking (Issue #183) ───────────────────────────────────────────
